import React, { useEffect, useState, createElement } from 'react';
import { useStatsData } from './hooks/useStatsData';
import { StatsHeader } from './components/StatsHeader';
import { CardIntimacyProgress } from './components/CardIntimacyProgress';
import { CardAchievements } from './components/CardAchievements';
import { CardRelationshipSnapshot } from './components/CardRelationshipSnapshot';
import { CardLootboxStats } from './components/CardLootboxStats';
import { CardRewardHubStats } from './components/CardRewardHubStats';
import { CardActivitySummary } from './components/CardActivitySummary';
import { CardSmartNudges } from './components/CardSmartNudges';
export const StatsPage: React.FC = () => {
  const {
    loading,
    error,
    intimacy,
    achievements,
    relationships,
    lootboxes,
    rewards,
    activity,
    nudges
  } = useStatsData();
  const [timeFilter, setTimeFilter] = useState<'7days' | '30days' | 'alltime'>('7days');
  return <div className="relative w-full max-w-7xl mx-auto space-y-6 overflow-hidden" data-id="element-21096">
      {/* Content with relative positioning */}
      <div className="relative z-10" data-id="element-21097">
        <StatsHeader totalRewards={rewards?.totalClaimed || 0} badgesOwned={achievements?.unlockedCount || 0} skinsOwned={rewards?.skinsOwned || 0} data-id="element-21098" />
        {error && <div className="bg-red-50 dark:bg-red-900/30 border border-red-200/50 dark:border-red-500/30 rounded-lg p-4 mb-4 backdrop-blur-sm" data-id="element-21099">
            <p className="text-red-600 dark:text-red-300 text-sm" data-id="element-21100">
              We couldn't load all your stats. Please try again later.
            </p>
          </div>}
        {/* Row 1: Progress Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-21101">
          <CardIntimacyProgress loading={loading} data={intimacy} data-id="element-21102" />
          <CardAchievements loading={loading} data={achievements} data-id="element-21103" />
          <CardRelationshipSnapshot loading={loading} data={relationships} data-id="element-21104" />
        </div>
        {/* Row 2: Value & Inventory */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-21105">
          <CardLootboxStats loading={loading} data={lootboxes} data-id="element-21106" />
          <CardRewardHubStats loading={loading} data={rewards} data-id="element-21107" />
        </div>
        {/* Row 3: Behavior & Coaching */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-21108">
          <div className="md:col-span-2" data-id="element-21109">
            <CardActivitySummary loading={loading} data={activity} timeFilter={timeFilter} onTimeFilterChange={setTimeFilter} data-id="element-21110" />
          </div>
          <div data-id="element-21111">
            <CardSmartNudges loading={loading} nudges={nudges} data-id="element-21112" />
          </div>
        </div>
      </div>
    </div>;
};